import React from "react";
import { Link, ListItem,  ListItemText, List, ListSubheader, Stack, IconButton } from '@mui/material';
import LaunchIcon from '@mui/icons-material/Launch';
import CloseIcon from '@mui/icons-material/Close';


const ComplaintsFull = (props) => {


    
var {nhtsaIdNumber, numberOfInjuries, numberOfDeaths, fire, crash, vin, consumerLocation, 
    description, components, associatedDocumentsCount,  associatedDocuments, associatedProductsCount, associatedProducts, setOpen} = props;

return (
    <List
        sx={{
            margin: 0,
            padding: 0,
            width: '100%',
            borderRadius: 2,
            borderColor: 'divider',
            backgroundColor: 'background.paper',
        }}
    >
         <Stack sx={{backgroundColor: "#e7e3e3", padding: "10px"}} justifyContent={"space-between"} direction={'row'} alignItems={'center'}>
            <ListItemText primary={`NHTSA ID: ${nhtsaIdNumber}`} />
            <IconButton onClick={()=>setOpen(false)}><CloseIcon size="large" color="error"/></IconButton>
        </Stack>
        <ListItem>
            <ListItemText primary={`VIN: ${vin}`} secondary= {`${description}`} />
        </ListItem>
        <ListItem>
            <ListItemText primary={`Consumer Location`} secondary= {`${consumerLocation}`} />
        </ListItem>
        <ListItem>
            <ListItemText primary="Nhtsa Number" secondary= {`${nhtsaIdNumber}`} />
            <ListItemText primary="Associated Documents" secondary= {`${associatedDocumentsCount}`} />
            <ListItemText primary="Affected Products" secondary= {`${associatedProductsCount}`} />
            <ListItemText primary="Number Of Injuries" secondary= {`${numberOfInjuries}`} />
            <ListItemText primary="Number Of Deaths" secondary= {`${numberOfDeaths}`} />
            <ListItemText primary="Fire" secondary= {`${fire}`} />
            <ListItemText primary="Crash" secondary= {`${crash}`} />
            <ListItemText primary="Components" secondary= {`${components.map(c=>c.name)}`} />
        </ListItem>
        <ListItem sx={{backgroundColor: "#e7e3e3"}}>
            <ListItemText primary={`Associated Documents`} />
        </ListItem>
        {associatedDocuments.map((a, i)=>
            
                <Link key={i} href={`${a.url}`} underline="none" target="_blank">
                    <ListItem >
                    <ListSubheader><LaunchIcon /></ListSubheader>
                    <ListItemText primary={`${a.summary}`} secondary= {`${a.fileName}`} />
                    </ListItem>
                </Link>
            
        )}
        <ListItem sx={{backgroundColor: "#e7e3e3"}}>
            <ListItemText primary={`Affected Products`} />
        </ListItem>
        {associatedProducts.map((a, i)=>
            <ListItem key={i}>
                <ListSubheader>{a.type}</ListSubheader>
                <ListItemText primary={`Manufacturer: ${a.manufacturer}`} secondary= {`${a.productMake} / ${a.productModel} / ${a.size}`} />
            </ListItem>
        )}
    </List>
)}

export default ComplaintsFull;